import * as constants from './constants';

/* Project instances */
export const getInstances = (projectId) => ({
  type: constants.GET_INSTANCES,
  projectId
});

export const getInstancesSuccess = (projectId, instances) => ({
  type: constants.GET_INSTANCES_SUCCESS,
  projectId,
  instances
});

export const getInstancesError = (projectId, error) => ({
  type: constants.GET_INSTANCES_ERROR,
  projectId,
  error
});

/* Project instances status */
export const getInstancesStatuses = (projectId) => ({
  type: constants.GET_INSTANCES_STATUSES,
  projectId
});

export const getInstancesStatusesSuccess = (projectId, instancesStatuses) => ({
  type: constants.GET_INSTANCES_STATUSES_SUCCESS,
  projectId,
  instancesStatuses
});

export const getInstancesStatusesError = (projectId, error) => ({
  type: constants.GET_INSTANCES_STATUSES_ERROR,
  projectId,
  error
});

/* Update project instance */
export const updateInstance = (projectId, instanceId, instance, actions) => ({
  type: constants.UPDATE_INSTANCE,
  projectId,
  instanceId,
  instance,
  actions
});

export const updateInstanceSuccess = (projectId, instanceId, instance) => ({
  type: constants.UPDATE_INSTANCE_SUCCESS,
  projectId,
  instanceId,
  instance
});

export const updateInstanceError = (projectId, instanceId, error) => ({
  type: constants.UPDATE_INSTANCE_ERROR,
  projectId,
  instanceId,
  error
});
